<script lang="ts">
	import AbleyButton from './AbleyButton.svelte';
	import IconChevronDown from '#lib/assets/chevron-down.svg?raw';

	interface Props {
		collapsed: boolean;
		oncollapsetoggle: () => void;
		/** Name the panel this toggles, so adjacent toggles are distinguishable. */
		'aria-label': string;
	}

	const { collapsed, oncollapsetoggle, 'aria-label': ariaLabel }: Props = $props();
</script>

<AbleyButton
	variant="text"
	size="sm"
	onclick={oncollapsetoggle}
	aria-label={ariaLabel}
	aria-expanded={!collapsed}>
	<span class="collapseIcon" class:expanded={!collapsed}>
		{@html IconChevronDown}
	</span>
</AbleyButton>

<style>
	.collapseIcon {
		display: block;
		transition: transform 0.15s ease-out;
		width: var(--icon-md);
		height: var(--icon-md);

		&.expanded {
			transform: rotate(180deg);
		}
	}
</style>
